module.exports = __webpack_public_path__ + "assets/2a93a7351066bcd85f235fd867abb751.mp3";